// T2-B event tracking admin dashboard MobX store (2026-05-04 PR 6b).

import { UserEventsAdminApi } from '@/apis';
import { ResponseData } from '@/types/http';
import { flow, makeObservable, observable } from 'mobx';
import RootStore from '.';
import BaseStore from './BaseStore';

export default class UserEventsAdminStore extends BaseStore {
    statsRows: any[] = [];
    aggregateRows: any[] = [];
    topRows: any[] = [];
    topMetric: 'motif' | 'landmark' | 'sponsor' | null = null;
    loading: boolean = false;
    api: UserEventsAdminApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            statsRows: observable,
            aggregateRows: observable,
            topRows: observable,
            topMetric: observable,
            loading: observable,
            fetchStats: flow.bound,
            fetchAggregate: flow.bound,
            fetchTop: flow.bound
        });
        this.api = new UserEventsAdminApi();
    }

    *fetchStats(payload: any) {
        try {
            this.loading = true;
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.stats, payload);
            if (res?.ok) {
                this.statsRows = res.data?.rows ?? [];
            }
            return res;
        } catch (_e) {
            return null;
        } finally {
            this.loading = false;
        }
    }

    *fetchAggregate(payload: any) {
        try {
            this.loading = true;
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.aggregate, payload);
            if (res?.ok) {
                this.aggregateRows = res.data?.rows ?? [];
            }
            return res;
        } catch (_e) {
            return null;
        } finally {
            this.loading = false;
        }
    }

    *fetchTop(payload: any) {
        try {
            this.loading = true;
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.top, payload);
            if (res?.ok) {
                this.topRows = res.data?.rows ?? [];
                this.topMetric = res.data?.metric ?? payload.metric;
            }
            return res;
        } catch (_e) {
            return null;
        } finally {
            this.loading = false;
        }
    }
}
